import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  FEATURE_AU_AI_EXPERIMENT,
  FEATURE_PH_AI_EXPERIMENT,
} from 'src/app/shared/featureToggle';
import { useFeatureToggleContext } from 'src/app/shared/featureToggle/context/FeatureToggleContext';
import { getFeatureByName } from 'src/app/shared/featureToggle/utils/getFeatureByName';
import {
  auAiExperimentControlGroup,
  auAiExperimentTestGroup,
  phAiExperimentControlGroup as phAiExperimentControlGroup,
  phAiExperimentTestGroup as phAiExperimentTestGroup,
} from 'src/app/v1/analytics/experiments';
import { actionUpdateExperiments } from 'src/app/v1/state/modules/tealium/experiments';

export const useExperiments = (): void => {
  const { features } = useFeatureToggleContext();

  const isPhAiExperimentFeature = getFeatureByName(
    features,
    FEATURE_PH_AI_EXPERIMENT,
  );
  const isPhAiExperimentFeatureEnabled = isPhAiExperimentFeature?.enabled;

  const isAuAiExperimentFeature = getFeatureByName(
    features,
    FEATURE_AU_AI_EXPERIMENT,
  );
  const isAuAiExperimentFeatureEnabled = isAuAiExperimentFeature?.enabled;

  const dispatch = useDispatch();

  useEffect(() => {
    const experiments = [];

    if (isPhAiExperimentFeatureEnabled !== undefined) {
      const phAiExperimentGroup = isPhAiExperimentFeatureEnabled
        ? phAiExperimentTestGroup
        : phAiExperimentControlGroup;

      experiments.push(phAiExperimentGroup);
    }

    if (isAuAiExperimentFeatureEnabled !== undefined) {
      const auAiExperimentGroup = isAuAiExperimentFeatureEnabled
        ? auAiExperimentTestGroup
        : auAiExperimentControlGroup;

      experiments.push(auAiExperimentGroup);
    }

    if (experiments.length > 0) {
      dispatch(actionUpdateExperiments(experiments));
    }
  }, [
    dispatch,
    isPhAiExperimentFeatureEnabled,
    isAuAiExperimentFeatureEnabled,
  ]);
};
